import { applicationPrepaidsApiV2 } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_PREPAIDS_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/prepaids`,
  {
    GET_PREPAIDS: 'GET_PREPAIDS',
    EDIT_PREPAIDS: 'EDIT_PREPAIDS',
  },
);

export const getLoanPrepaidsActionV2 = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationPrepaidsApiV2.getLoanPrepaids(params);

  return dispatch({
    type: LOAN_PREPAIDS_ACTION_TYPE.GET_PREPAIDS,
    payload: data,
  });
});

export const editLoanPrepaidsActionV2 = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationPrepaidsApiV2.editLoanPrepaids(params);

  return dispatch({
    type: LOAN_PREPAIDS_ACTION_TYPE.EDIT_PREPAIDS,
    payload: data,
  });
});
